import { METHOD } from "../../data/site";
import { Lines, Reveal } from "../motion";

export const Method = ({ eyebrowN = "04" }) => (
  <section className="bg-ink px-5 py-24 text-paper sm:px-10 md:py-36 lg:px-16" data-testid="method-section">
    <div className="grid grid-cols-12 gap-y-16 lg:gap-x-10">
      <div className="col-span-12 lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <p className="eyebrow flex items-center gap-3 !text-mint">
              <span className="font-serif text-sm tracking-normal">{eyebrowN}</span>
              <span className="h-px w-8 bg-mint/50" aria-hidden="true" />Metodo
            </p>
          </Reveal>
          <Lines lines={["Un processo chiaro,", "dall'ascolto ai dati."]} className="mt-8 text-4xl leading-[1.1] sm:text-5xl" />
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-sm text-base leading-relaxed text-paper/75">
              Ogni progetto segue quattro fasi. Le stesse persone ti accompagnano dall'inizio alla fine, senza passaggi di mano.
            </p>
          </Reveal>
        </div>
      </div>
      <ol className="col-span-12 lg:col-span-6 lg:col-start-7">
        {METHOD.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.05} className="grid grid-cols-6 gap-4 border-t border-paper/15 py-10 md:py-14">
            <li className="contents" data-testid={`method-step-${m.n}`}>
              <span className="col-span-1 font-serif text-4xl text-mint md:text-5xl">{m.n}</span>
              <div className="col-span-5 md:col-span-4 md:col-start-3">
                <h3 className="text-2xl md:text-3xl">{m.title}</h3>
                <p className="mt-4 text-base leading-relaxed text-paper/75">{m.text}</p>
              </div>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
